/**
 * Leaflet implementation for displaying map widgets with sites.
 *
 * @author Vašek Brychta <vaclav@brychtovi.cz>
 * @version 2018-01-22
 */

(function (window, $, Foundation, undefined) {

	if (typeof $ !== 'function') {
		return console.error('brko.mapWidget.js: jQuery is missing, load it please');
	}

	var mapWidget = function () {
		this.options = {
			mapContainerId: undefined,
			followUserLocation: false,
			defaultZoom: 17
		};

		/**
		 * Initialize map widget.
		 *
		 * @param {object} options
		 * @param {string} options.mapContainerId
		 * @param {bool} options.followUserLocation
		 * @param {int} options.defaultZoom
		 * @returns {mapWidget|undefined}
		 */
		this.init = function (options) {
			$.extend(this.options, options);

			if (this.options.mapContainerId === undefined || this.options.mapContainerId.length === 0) {
				return undefined;
			}
			if (!this.checkRequirements()) {
				return undefined;
			}

			var $mapContainer = $('#' + this.options.mapContainerId);
			if ($mapContainer.length === 0) {
				return undefined;
			}

			this._data = this._loadData($mapContainer);
			this._map = this._createMap(this.options);
			this._startAdjustingMapHeight($mapContainer);

			this._createAndDrawTeamsLayer();

			if (this._shouldFollowUser()) {
				this._activateFollowUserMode();
			} else {
				this._activatePointsMode();
			}

			return this;
		};

		/**
		 * Basic sanity check before run.
		 *
		 * @returns {boolean}
		 */
		this.checkRequirements = function () {
			if (typeof window.L !== 'object') {
				console.error('brko.mapWidget.js: Leaflet library is missing, load it please');
				return false;
			}
			return true;
		};

		// region Inner properties
		this._L = window.L;
		this._data = {
			sites: undefined,
			filteredSites: undefined,
			locations: undefined,
			teams: undefined,
			tileUrls: undefined
		};
		this._map = undefined;
		this._layers = {
			teams: undefined,
			locations: undefined,
			sites: undefined,
			sitesTooltips: undefined
		};
		this._controls = {
			locate: undefined
		};
		// endregion Inner properties

		this._loadData = function ($mapContainer) {
			return {
				sites: $mapContainer.data('sites'),
				filteredSites: $mapContainer.data('sites'),
				locations: $mapContainer.data('locations'),
				teams: $mapContainer.data('teams'),
				tileUrls: $mapContainer.data('tileurls')
			};
		};

		this._createMap = function (options) {
			var map = this._L.map(options.mapContainerId).setZoom(options.defaultZoom);//.setView([49.224367, 17.664439], 15);
			var seznamTileLayer = this._L.tileLayer("//mapserver.mapy.cz/turist-m/{z}-{x}-{y}", {
				minZoom: 5,
				maxZoom: 18,
				zoomSnap: 0.1,
				zoomDelta: 0.1,
				attribution: '<img src="//mapy.cz/img/logo-small.svg" style="height: 10px" /> © <a href="//www.seznam.cz" target="_blank">Seznam.cz, a.s.</a>'
			});
			//seznamTileLayer.addTo(map);
			var osmTileLayer = this._L.tileLayer("//tile.openstreetmap.org/{z}/{x}/{y}.png", {
				minZoom: 5,
				maxZoom: 18,
				zoomSnap: 0.1,
				zoomDelta: 0.1,
				attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
			});
			osmTileLayer.addTo(map);

			if (this._data.tileUrls) {
				var that = this;
				// var tileLayers = {'Mapy.cz': seznamTileLayer};
				var tileLayers = {'OpenStreetMap': osmTileLayer};

				this._data.tileUrls.forEach(function (layerSettings) {
					var customTileLayer = that._L.tileLayer(layerSettings.url, {
						minZoom: 5,
						maxZoom: 18,
						zoomSnap: 0.1,
						zoomDelta: 0.1,
						attribution: ''
					});
					customTileLayer.addTo(map);
					tileLayers[layerSettings.name] = customTileLayer;
				});

				this._L.control.layers(tileLayers).addTo(map);
			}

			this._L.control.fullscreen({pseudoFullscreen: true}).addTo(map);
			this._L.control.scale({imperial: false, maxWidth: 100}).addTo(map);

			return map;
		};

		this._startAdjustingMapHeight = function ($mapContainer) {
			this._adjustElementHeight($mapContainer);
			this._registerMapHeigthAdjustmentOnEvents($mapContainer);
		};

		this._createAndDrawTeamsLayer = function () {
			var markers = this._createMarkersForTeams();

			this._layers.teams = this._createLayerWithMarkers(markers);
		};

		this._shouldFollowUser = function () {
			var coordinates = this._getAllCoordinates();

			return coordinates.length === 0;
		};

		this._activateFollowUserMode = function () {
			this._startLocate(true);
		};

		this._activatePointsMode = function () {
			var coordinates = this._getAllCoordinates();
			if (coordinates.length === 1) {
				this._map.setView(coordinates[0], this.options.defaultZoom);
			} else {
				this._fitBoundsToCoordinates(coordinates);
			}


			this._createAndDrawSitesLayer();
			this._createAndDrawLocationsLayer();

			this._startLocate(false);
		};

		this._adjustElementHeight = function ($element, adjustment) {
			if (adjustment === undefined) {
				adjustment = 0;
			}
			$element.height(Math.max(Math.round($(window).height() - $element.offset().top - 30 + adjustment), 200) + "px");
		};

		this._registerMapHeigthAdjustmentOnEvents = function ($mapContainer) {
			$(window).on('resize', function () {
				this._adjustElementHeight($mapContainer);
			}.bind(this));

			this._map.on('fullscreenchange', function () {
				var topbar = $(".top-bar");
				var adjustment = 0;
				if (topbar !== undefined && topbar.length > 0 && topbar.hasClass("expanded")) {
					adjustment = topbar.height() - $(".title-area", topbar).height();
				}
				if (!this._map.isFullscreen()) {
					this._adjustElementHeight($mapContainer, adjustment);
				}
			}.bind(this));
		};

		this._createMarkersForTeams = function () {
			if (this._data.teams === undefined) {
				return [];
			}

			var markers = [];
			for (i = 0; i < this._data.teams.length; i++) {
				markers.push(this._createMarkerForOneTeam(this._data.teams[i]));
			}

			return markers;
		};

		this._createMarkerForOneTeam = function (team) {
			var icon = this._L.ExtraMarkers.icon({
													 icon: 'fa-child',
													 markerColor: 'orange',
													 shape: 'square',
													 prefix: 'fa',
													 extraClasses: 'fa-fw'
												 });
			var marker = this._L.marker(team.coords, {icon: icon});
			var tooltip = this._L.tooltip({
											  direction: 'top',
											  offset: [2, -40]
										  })
				.setContent(team.name);
			marker.bindTooltip(tooltip);

			return marker;
		};

		this._createLayerWithMarkers = function (markers) {
			if (markers.length === 0) {
				return undefined;
			}

			var markersLayer = this._L.layerGroup(markers);
			this._map.addLayer(markersLayer);

			return markersLayer;
		};

		this._getAllCoordinates = function () {
			var coordinates = this._getCoordinatesForSites();

			Array.prototype.push.apply(coordinates, this._getCoordinatesForLocations());

			return coordinates;
		};

		this._getCoordinatesForSites = function () {
			if (this._data.filteredSites === undefined) {
				return [];
			}

			var coordinates = [];

			for (i = 0; i < this._data.filteredSites.length; i++) {
				var site = this._data.filteredSites[i];
				for (j = 0; j < site.locations.length; j++) {
					coordinates.push(site.locations[j].coords);
				}
			}

			return coordinates;
		};

		this._getCoordinatesForLocations = function () {
			if (this._data.locations === undefined) {
				return [];
			}

			var coordinates = [];

			for (i = 0; i < this._data.locations.length; i++) {
				coordinates.push(this._data.locations[i]);
			}

			return coordinates;
		};

		this._startLocate = function (followUserLocation) {
			if (this._controls.locate !== undefined) {
				this._map.removeControl(this._controls.locate);
				this._controls.locate = undefined;
			}

			this._controls.locate = this._L.control.locate({
															   setView: followUserLocation ? 'untilPan' : false,
															   locateOptions: {
																   enableHighAccuracy: true
															   },
															   cacheLocation: true
														   });
			this._map.addControl(this._controls.locate);
			this._controls.locate.start();
		};

		this._fitBoundsToCoordinates = function (coordinates) {
			this._map.fitBounds(coordinates, {padding: [30, 30]});
		};

		this._createAndDrawSitesLayer = function () {
			this._clearSitesLayer();
			this._clearSitesTooltipsLayer();

			if (this._data.filteredSites === undefined) {
				return;
			}

			var markers = [];
			var tooltips = [];
			for (i = 0; i < this._data.filteredSites.length; i++) {
				var site = this._data.filteredSites[i];
				var locationNumber = site.locations.length > 1 ? 1 : undefined;

				for (j = 0; j < site.locations.length; j++) {
					var location = site.locations[j];
					markers.push(this._createSiteMarker(site, location.coords));
					var tooltip = this._createSiteTooltip(site, location, locationNumber);
					if (tooltip !== undefined) {
						tooltips.push(tooltip);
					}
					if (locationNumber !== undefined)
						locationNumber++;
				}
			}

			this._layers.sites = this._createLayerWithMarkers(markers);
			this._layers.sitesTooltips = this._createLayerWithMarkers(tooltips);
			this._layers.sitesTooltips.getPane().style.pointerEvents = 'none';
		};

		this._clearSitesLayer = function () {
			if (this._layers.sites !== undefined) {
				this._map.removeLayer(this._layers.sites);
				this._layers.sites = undefined;
			}
		};

		this._clearSitesTooltipsLayer = function () {
			if (this._layers.sitesTooltips !== undefined) {
				this._map.removeLayer(this._layers.sitesTooltips);
				this._layers.sitesTooltips = undefined;
			}
		};

		this._createSiteMarker = function (site, coordinates) {
			var marker = this._L.marker(coordinates, {icon: this._createIconForSite(site)});
			if (site.link && site.link.url) {
				marker.on('click', function () {
					if (site.link.confirmation) {
						this._showConfirmationDialog(site.link.url);
					} else {
						location.href = site.link.url;
					}
				}.bind(this));
			}

			return marker;
		};

		this._createIconForSite = function (site) {
			return this._L.ExtraMarkers.icon({
												 icon: site.visual.icon,
												 iconColor: site.visual.iconColor,
												 markerColor: site.visual.color,
												 shape: site.visual.shape,
												 prefix: 'fa',
												 extraClasses: 'fa-fw'
											 });
		};

		this._createSiteTooltip = function (site, location, locationNumber) {
			var description = this._makeSiteTooltipDescription(site, locationNumber);
			if (description) {
				var offset = [2, 0];
				if (location.labelPosition === 'top') {
					offset = [2, -40];
				}
				return this._L.tooltip({
										   permanent: true,
										   direction: location.labelPosition,
										   offset: offset
									   })
					.setLatLng(location.coords)
					.setContent(description);
			}

			return undefined;
		};

		this._makeSiteTooltipDescription = function (site, locationNumber) {
			var description = '';
			if (site.code !== undefined && site.code.length > 0) {
				description = site.code;
				if (locationNumber !== undefined)
					description += locationNumber;
			}
			if (site.points !== undefined && site.points.length > 0) {
				if (description) {
					description += ': ';
				}
				description += site.points;
			}
			return description;
		};

		this._createAndDrawLocationsLayer = function () {
			var icon = this._L.ExtraMarkers.icon({
													 icon: 'fa-eye',
													 markerColor: 'blue',
													 shape: 'circle',
													 prefix: 'fa',
													 extraClasses: 'fa-fw'
												 });
			var coordinates = this._getCoordinatesForLocations();

			var markers = [];
			for (i = 0; i < coordinates.length; i++) {
				markers.push(this._L.marker(coordinates[i], {icon: icon}));
			}

			this._layers.locations = this._createLayerWithMarkers(markers);
		};

		this._showConfirmationDialog = function (url) {
			$.nette.ajax({
							 url: url,
							 off: ['history', 'scrollTo'],
							 confirm: true
						 });
		};
	};

	if (window.brko === undefined) {
		window.brko = new (function () {
		});
	}

	window.brko.mapWidget = function (options) {
		return new mapWidget().init(options);
	};

})(window, window.jQuery, window.Foundation);
